import React from "react";
import CourseCategoryManager from "./CourseCategoryManager";

function ViewCategory() {
  return <CourseCategoryManager />;
}

export default ViewCategory;
